// 发布订阅：


// 使用手册：


// -----main.js----全局挂载 

// import { CommonBus, UniqueBus } from '@/assets/js/bus.js';

// let VuePro = Vue.prototype;

// VuePro.$bus = new CommonBus();         //bus工具
// VuePro.$bus_unique = new UniqueBus();  //单一bus（仅供订阅一次）



// -----页面使用：

//监听：

// this.$bus.on('name', (options) => {
//     console.info('options', options);
// });


// 触发：

// this.$bus.emit('name', (options) => {
//     console.info('options', options);
// });


//移除：

// this.$bus.off('name');


class CommonBus {
    constructor() {
        this.busList = [];
    };

    on(messName, cb) {
        this.busList.push({
            name: messName,
            cb
        });
    };

    off(messName) {
        let _busList = this.busList;

        _busList.forEach(item => {
            if (item.name === messName) {
                item.isRemove = true;
            }
        });

        this.busList = _busList.filter(item => item.isRemove !== true);
    };

    emit(messName, data) {
        this.busList.forEach(item => {
            if (item.name === messName) {
                item.cb(data);
            }
        });
    };
}





// -----页面使用：

//监听：

// this.$bus_unique.on('eventName', 'uni-key', (options) => {
//     console.info('options', options);
// });


// 触发：

// this.$bus_unique.emit('eventName', (options) => {
//     console.info('options', options);
// });


//移除：

// this.$bus_unique.off('eventName'); // 全部移除
// this.$bus_unique.off('eventName', 'uni-key'); // 部分移除 |  uni-key事件

class UniqueBus {
    constructor() {
        this.busListObj = {};
    }

    on(busName, uniqueID, cb) {
        const currentBus = this.busListObj[busName] || (this.busListObj[busName] = {});
        currentBus[uniqueID] = cb;
    }

    off(busName, uniqueID) {
        let _busListObj = this.busListObj;

        for (let key in _busListObj) {
            if (busName === key) {
                uniqueID ? delete _busListObj[key][uniqueID] : delete _busListObj[key]
            }
        }
    }

    emit(busName, data) {
        const myBusObj = this.busListObj[busName];

        console.info('myBusObj', myBusObj);

        for (let key in myBusObj) {
            myBusObj[key](data);
        }
    }
}


export {
    CommonBus,
    UniqueBus,
}